import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./startup/App";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import "react-app-polyfill/ie11";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
const root = document.getElementById("root");
ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  root
);
